<template>
  <div class="pv2">
    <!-- Cabecera: título + totales + filtros de tiempo -->
    <header class="pv2-card pv2-enter" style="--i: 0">
      <div class="pv2-head">
      <div>
        <h1 class="pv2-h1">Previsión</h1>
        <span class="pv2-muted" v-if="!cargando">{{ articulosBusquedaAll.length }} artículos</span>
      </div>
      <div class="pv2-filtros">
      <div class="pv2-filtro">
        <div class="pv2-filtro-head">
          <span class="pv2-label">Años</span>
          <button type="button" class="pv2-link" @click="toggleTodos(anyos)">{{ todosActivos(anyos) ? 'Ninguno' : 'Todos' }}</button>
        </div>
        <div class="pv2-chips">
          <button
            v-for="item in anyos" :key="'a' + item.value"
            type="button" class="pv2-chip" :class="{ 'is-on': item.active }" :aria-pressed="item.active"
            @click="item.active = !item.active"
          >{{ item.nombre }}</button>
        </div>
      </div>
      <div class="pv2-vr"></div>
      <div class="pv2-filtro">
        <div class="pv2-filtro-head">
          <span class="pv2-label">Meses</span>
          <button type="button" class="pv2-link" @click="toggleTodos(meses)">{{ todosActivos(meses) ? 'Ninguno' : 'Todos' }}</button>
        </div>
        <div class="pv2-chips">
          <button
            v-for="item in meses" :key="'m' + item.value"
            type="button" class="pv2-chip" :class="{ 'is-on': item.active }" :aria-pressed="item.active"
            @click="item.active = !item.active"
          >{{ item.nombre.slice(0, 3) }}</button>
        </div>
      </div>
      </div>
      <div class="pv2-stats">
        <div class="pv2-stat">
          <span class="pv2-stat-label"><span class="pv2-dot" style="background: var(--pv2-success)"></span>Coste</span>
          <span class="pv2-stat-value">{{ totalCoste }}</span>
        </div>
        <div class="pv2-stat">
          <span class="pv2-stat-label"><span class="pv2-dot" style="background: var(--pv2-primary)"></span>RRP</span>
          <span class="pv2-stat-value">{{ totalRRP }}</span>
        </div>
        <div class="pv2-stat">
          <span class="pv2-stat-label"><span class="pv2-dot" style="background: var(--pv2-warning)"></span>Stock marcado</span>
          <span class="pv2-stat-value">{{ valorCheck }}</span>
        </div>
      </div>
      </div>

    </header>

    <!-- Barra de herramientas -->
    <section class="pv2-card pv2-enter pv2-toolbar" style="--i: 1">
      <label class="pv2-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input v-model="buscar" type="search" class="pv2-input" placeholder="Buscar SKU o título…" aria-label="Buscar">
      </label>
      <div class="pv2-field">
        <label>Mostrar</label>
        <v-select v-model="mostrarSelect" :options="listadoMostrar" :clearable="false" append-to-body />
      </div>
      <div class="pv2-field">
        <label>Localización</label>
        <v-select v-model="localizacionSelect" :options="listadoLocalizacion" :clearable="false" append-to-body />
      </div>
      <div class="pv2-field">
        <label>Tipo SKU</label>
        <v-select v-model="tipoSelect" :options="listadoTipo" :clearable="false" append-to-body />
      </div>
      <div class="pv2-field">
        <label>Pedido</label>
        <v-select v-model="pedidoSelect" :options="listadoPedido" :clearable="false" append-to-body />
      </div>
      <div class="pv2-field">
        <label>Agrupar</label>
        <div class="pv2-seg" role="group" aria-label="Agrupar">
          <button type="button" :class="{ 'is-on': agruparPor == 'sku' }" :aria-pressed="agruparPor == 'sku'" @click="cambiarAgrupado('sku')">SKU</button>
          <button type="button" :class="{ 'is-on': agruparPor == 'title' }" :aria-pressed="agruparPor == 'title'" @click="cambiarAgrupado('title')">Título</button>
        </div>
      </div>
      <div class="pv2-actions">
        <button v-if="mostrarSelect == 'Pedido Actual'" type="button" class="pv2-btn pv2-btn-primary" @click="generarPedido()">
          <i class="fa-solid fa-wand-magic-sparkles"></i> Generar pedido
        </button>
        <button type="button" class="pv2-btn pv2-btn-icon" @click="descargarExcell()" v-b-tooltip.hover title="Copiar CSV al portapapeles" aria-label="Copiar CSV al portapapeles">
          <i class="fa-solid fa-file-csv"></i>
        </button>
        <button type="button" class="pv2-btn pv2-btn-icon pv2-btn-danger" @click="borrarTodo()" v-b-tooltip.hover title="Borrar todos los pedidos" aria-label="Borrar todos los pedidos">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>
    </section>

    <!-- Tabla -->
    <section class="pv2-card pv2-enter pv2-tabla" style="--i: 2">
      <div v-if="cargando" class="pv2-skeleton" aria-busy="true" aria-label="Cargando datos">
        <div v-for="n in 10" :key="n" class="pv2-skel-row"></div>
      </div>
      <template v-else>
        <div v-if="articulosBusqueda.length == 0" class="pv2-empty">
          <i class="fa-solid fa-folder-open"></i>
          <p>Sin resultados<span v-if="buscar"> para «{{ buscar }}»</span></p>
          <button v-if="buscar" type="button" class="pv2-link" @click="buscar = ''">Limpiar búsqueda</button>
        </div>
        <b-table
          v-else
          :items="articulosBusqueda"
          :fields="columnasTable"
          :tbody-tr-class="filaClaseV2"
          class="pv2-table mb-0"
          no-border-collapse
          sort-icon-left
          @sort-changed="sortChanged"
          ref="table"
        >
          <template #cell(check)="data">
            <b-form-checkbox v-if="!data.item.esGrupo" v-model="data.item.check" class="pv2-check" />
          </template>

          <template #cell(sku)="data">
            <!-- Fila de grupo (agrupado por título) -->
            <div v-if="data.item.esGrupo" class="pv2-sku-celda">
              <button type="button" class="pv2-ibtn" @click="toggleGrupo(data.item)" :aria-expanded="!!expandidos[data.item.title]" aria-label="Desplegar">
                <i class="fa-solid fa-chevron-right pv2-chev" :class="{ 'is-open': expandidos[data.item.title] }"></i>
              </button>
              <span class="pv2-sku pv2-grupo-titulo" @click="toggleGrupo(data.item)">{{ data.item.title }}</span>
              <span class="pv2-count">{{ data.item.skus.length }}</span>
              <button type="button" class="pv2-ibtn pv2-ghost-act" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver gráfica" aria-label="Ver gráfica">
                <i class="fa-solid fa-chart-line"></i>
              </button>
            </div>
            <!-- Fila hija (agrupado por título): controles inline -->
            <div v-else-if="agruparPor == 'title'" class="pv2-sku-celda">
              <b-form-checkbox v-model="data.item.check" class="pv2-check" />
              <span class="pv2-sku">{{ data.item.sku }}</span>
              <button type="button" class="pv2-ibtn pv2-ghost-act" @click="copySkuClipboard(data.item)" v-b-tooltip.hover title="Copiar SKU" aria-label="Copiar SKU">
                <i class="fa-solid fa-copy"></i>
              </button>
              <button type="button" class="pv2-ibtn pv2-ghost-act" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver gráfica" aria-label="Ver gráfica">
                <i class="fa-solid fa-chart-line"></i>
              </button>
              <div class="ml-auto" @click="cambiarLocalizacion(data.item)">
                <b-form-checkbox class="custom-control-success pv2-switch" switch v-model="data.item.localizacion">
                  <span class="switch-icon-left">Ubr</span>
                  <span class="switch-icon-right">Elc</span>
                </b-form-checkbox>
              </div>
            </div>
            <!-- Fila normal -->
            <div v-else class="pv2-sku-celda">
              <div class="pv2-sku-bloque">
                <span class="pv2-sku">{{ data.item.sku }}</span>
                <span class="pv2-sku-titulo">{{ data.item.title }}</span>
              </div>
              <button type="button" class="pv2-ibtn pv2-ghost-act" @click="copySkuClipboard(data.item)" v-b-tooltip.hover title="Copiar SKU" aria-label="Copiar SKU">
                <i class="fa-solid fa-copy"></i>
              </button>
              <button type="button" class="pv2-ibtn pv2-ghost-act" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver gráfica" aria-label="Ver gráfica">
                <i class="fa-solid fa-chart-line"></i>
              </button>
            </div>
          </template>

          <template #cell(localizacion)="data">
            <div v-if="!data.item.esGrupo" @click="cambiarLocalizacion(data.item)">
              <b-form-checkbox class="custom-control-success pv2-switch" switch v-model="data.item.localizacion">
                <span class="switch-icon-left">Ubr</span>
                <span class="switch-icon-right">Elc</span>
              </b-form-checkbox>
            </div>
          </template>

          <template #cell(pedidoActual)="data">
            <span v-if="data.item.esGrupo">{{ data.item.pedidoActual }}</span>
            <input
              v-else
              v-model.lazy="data.item.pedidoActual"
              type="number" min="0" class="pv2-num-input" :class="{ 'has-value': data.item.pedidoActual }"
              @wheel.prevent @focus="togglePicker(data)" aria-label="Pedido actual"
            >
          </template>

          <template #cell(pedidoAnual)="data">
            <span v-if="data.item.esGrupo">{{ data.item.pedidoAnual }}</span>
            <input
              v-else
              v-model.lazy="data.item.pedidoAnual"
              type="number" min="0" class="pv2-num-input" :class="{ 'has-value': data.item.pedidoAnual }"
              @wheel.prevent @focus="togglePicker(data)" aria-label="Pedido anual"
            >
          </template>

          <template #cell(stockIdeal)="data">
            <span :class="{ 'pv2-falta': data.item.stockIdeal }">{{ data.item.stockIdeal }}</span>
          </template>
        </b-table>

        <div ref="sentinela" style="height: 1px;"></div>
      </template>
    </section>

    <!-- Barra de selección (aparece con artículos marcados) -->
    <transition name="pv2-pop">
      <div v-if="numCheck > 0" class="pv2-selbar" role="status">
        <span><strong>{{ numCheck }}</strong> seleccionados</span>
        <span class="pv2-selbar-sep"></span>
        <span>Stock <strong>{{ valorCheck }}</strong></span>
        <button type="button" class="pv2-btn" @click="descargarExcell()"><i class="fa-solid fa-file-csv"></i> Copiar CSV</button>
        <button type="button" class="pv2-btn" @click="limpiarCheck()">Limpiar</button>
      </div>
    </transition>

    <!-- Modal gráfica -->
    <b-modal id="modal-analityc" centered size="xl" hide-footer modal-class="pv2-modal">
      <template #modal-title>
        <span class="pv2-modal-sku">{{ itemSelect.sku }}</span>
        <span class="pv2-muted d-block">Ventas por mes</span>
      </template>
      <b-row>
        <b-col cols="12" lg="9">
          <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
        </b-col>
        <b-col cols="12" lg="3">
          <apexchart type="radar" height="350" :options="chartOptionsRadar" :series="series"></apexchart>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Prevision from './Prevision.vue'

// ponytail: hereda toda la lógica de Prevision.vue; aquí solo cambia la capa visual
const PALETA = ['#7367f0', '#00cfe8', '#28c76f', '#ff9f43', '#ea5455', '#9b8afb', '#1e9ff2', '#82868b']
const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

export default {
  name: 'PrevisionV2',
  extends: Prevision,
  data() {
    return {
      chartOptions: {
        chart: { type: 'line', height: 350, zoom: { enabled: false }, toolbar: { show: false }, fontFamily: 'inherit', animations: { speed: 300 } },
        colors: PALETA,
        stroke: { curve: 'smooth', width: 2 },
        markers: { size: 0, hover: { size: 5 } },
        dataLabels: { enabled: false },
        grid: { borderColor: 'rgba(128,128,128,.2)', strokeDashArray: 4, xaxis: { lines: { show: false } } },
        legend: { position: 'top', horizontalAlign: 'left' },
        xaxis: { categories: MESES, axisBorder: { show: false }, axisTicks: { show: false } },
        yaxis: { labels: { formatter: v => Math.round(v) } },
        tooltip: { shared: true, intersect: false },
      },
      chartOptionsRadar: {
        chart: { type: 'radar', height: 350, toolbar: { show: false }, fontFamily: 'inherit' },
        colors: PALETA,
        stroke: { width: 2 },
        fill: { opacity: 0.1 },
        markers: { size: 2 },
        legend: { show: false },
        dataLabels: { enabled: false },
        xaxis: { categories: MESES.map(m => m.slice(0, 3)) },
      },
    }
  },
  computed: {
    seleccionados() {
      return this.articulos.filter(x => x.check)
    },
    numCheck() {
      return this.seleccionados.length
    },
    valorCheck() {
      const total = this.seleccionados.reduce((acc, a) => acc + a.stock * a.precio, 0)
      return '£' + Math.round(total).toLocaleString('es-ES')
    },
  },
  methods: {
    cargarColumnas() {
      Prevision.methods.cargarColumnas.call(this)
      // "options" (copiar) va dentro de la celda SKU; el resto de columnas son numéricas.
      // Anchos fijos (con table-layout: fixed) para que no bailen al ordenar
      this.columnasTable = this.columnasTable
        .filter(c => c.key != 'options')
        .map(c => {
          if (c.key == 'sku') return Object.assign({}, c, { thStyle: { width: '320px' } })
          if (['check', 'localizacion'].includes(c.key)) return c
          return Object.assign({}, c, { class: 'pv2-num', thStyle: { width: '96px' } })
        })
    },
    todosActivos(lista) {
      return lista.every(x => x.active)
    },
    toggleTodos(lista) {
      const on = !this.todosActivos(lista)
      lista.forEach(x => { x.active = on })
    },
    filaClaseV2(item) {
      if (!item) return ''
      if (item.esGrupo) return 'pv2-row-grupo'
      if (item.esHijo && this.agruparPor == 'title') return 'pv2-row-hijo'
      return ''
    },
  },
}
</script>

<style lang="scss">
@import '../assets/scss/v2.scss';

// ─── Específico de Previsión ───────────────────────────────────────────────
.pv2-filtros {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  // En la fila de cabecera: no encoger (baja de línea entero si no cabe), pero nunca más ancho que la tarjeta
  flex-shrink: 0;
  max-width: 100%;
}

.pv2-filtro {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pv2-filtro-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.pv2-vr {
  width: 1px;
  background: var(--pv2-line);
  align-self: stretch;
}

.pv2 .pv2-table { table-layout: fixed; }

.pv2-row-grupo td {
  background: var(--pv2-soft);
  font-weight: 600;
}

.pv2-row-hijo td {
  color: var(--pv2-ink-2);
  &:first-child { padding-left: 28px; box-shadow: inset 3px 0 0 var(--pv2-line); }
}

.pv2-sku-celda {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  white-space: nowrap;
}

.pv2-sku-bloque {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.pv2-sku { font-weight: 500; }

.pv2-sku-titulo {
  font-size: 0.75rem;
  color: var(--pv2-ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}

.pv2-sku-celda { overflow: hidden; }
.pv2-sku, .pv2-grupo-titulo { min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.pv2-grupo-titulo { cursor: pointer; }

.pv2-check { margin: 0; }
.pv2-switch { margin: 0; }

.pv2-num-input {
  width: 64px;
  height: 30px;
  padding: 0 8px;
  text-align: right;
  border: 1px solid transparent;
  border-radius: 6px;
  background: var(--pv2-soft);
  color: var(--pv2-ink);
  font-size: 0.875rem;
  -moz-appearance: textfield;
  transition-property: border-color, box-shadow, background-color, color;
  transition-duration: 150ms;
  transition-timing-function: var(--pv2-ease);

  &::-webkit-inner-spin-button, &::-webkit-outer-spin-button { -webkit-appearance: none; }
  &:hover { border-color: var(--pv2-line); }
  &:focus {
    outline: 0;
    background: var(--pv2-bg);
    border-color: var(--pv2-primary);
    box-shadow: 0 0 0 3px var(--pv2-primary-soft);
  }
  &.has-value {
    background: var(--pv2-primary-soft);
    color: var(--pv2-primary);
    font-weight: 600;
  }
}

.pv2-falta {
  color: var(--pv2-warning);
  font-weight: 600;
}

// Barra de selección flotante
.pv2-selbar {
  position: fixed;
  left: 50%;
  bottom: 20px;
  translate: -50% 0;
  z-index: 1030;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 6px 6px 16px;
  border-radius: 14px; // 8 del botón + 6 de padding
  background: #1e1e2d;
  color: #fff;
  font-size: 0.875rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.08);
  white-space: nowrap;

  strong { font-weight: 600; }

  .pv2-btn {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    height: 34px;
  }
}

.pv2-selbar-sep {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.15);
}

@media (hover: hover) and (pointer: fine) {
  .pv2-selbar .pv2-btn:hover { background: rgba(255, 255, 255, 0.16); }
}

.pv2-pop-enter-active { transition: opacity 200ms var(--pv2-ease-out), translate 200ms var(--pv2-ease-out); }
.pv2-pop-leave-active { transition: opacity 150ms ease-out, translate 150ms ease-out; }
.pv2-pop-enter, .pv2-pop-leave-to { opacity: 0; translate: -50% 8px; }

.pv2-modal-sku {
  font-weight: 600;
  letter-spacing: -0.01em;
}

@media (prefers-reduced-motion: reduce) {
  .pv2-pop-enter-active, .pv2-pop-leave-active { transition: opacity 150ms ease-out; }
  .pv2-pop-enter, .pv2-pop-leave-to { translate: -50% 0; }
}

@media (max-width: 767px) {
  .pv2-vr { display: none; }
  .pv2-selbar { left: 16px; right: 16px; translate: none; flex-wrap: wrap; gap: 8px; }
  .pv2-pop-enter, .pv2-pop-leave-to { translate: 0 8px; }
}
</style>
